import React from 'react'
import { connect } from 'react-redux'

import Header from './Header'
import Footer from './Footer'
import LoginForm from '../components/LoginForm'
import { login, redirect } from '../actions'

import '../styles/login'

class Login extends React.Component {
    constructor() {
        super()
        this.login = this.login.bind(this)
    }
    login(username, password) {
        return this.props.login(username, password)
            .then(() => this.props.redirect('/'))
    }
    render() {
        return <LoginForm onSubmit={this.login} />
    }
}

export default connect(null, { login, redirect })(Login)


// WEBPACK FOOTER //
// ./containers/Login.jsx